import { MonoClineTc } from "@me8eon/components";
import { RelativeDayLabels, TimeService, timeToTimeString } from "@me8eon/time";
import { Message } from "@me8eon/messages";

export const sessionsAndMessagesDebugName = "sessionsAndMessages";

export type MessageWithActionAndData = Message & {
    action?: string;
    data?: any;
    enableNexthinkAction?: boolean;
    jql?: any;
    condition?: any
    toolCalls?: any[]
    id?: string
}

export type AISession = {
    id: string
    name: string
    time: string
    source?: "legacy" | "new"
    threadId?: string
}
export const AiSessionTc = (timeService: TimeService, locale?: string, labels?: RelativeDayLabels): MonoClineTc<AISession> => ({
    categorise: (value) => timeToTimeString(timeService, new Date(Date.parse(value.time)), locale, labels),
});

/** Puts every session in one group, so the list isn't split under date headers. */
export const AiSessionFlatTc: MonoClineTc<AISession> = {
    categorise: () => "all",
};

export type AiSessionData = {
    selected: string
    sessions: AISession[]
}
export const emptyAiSessionData: AiSessionData = {
    selected: "",
    sessions: [],
};
